// export { default as Zoom } from "./Zoom";
// export { default as KeyPoint } from "./KeyPoint";

import { Brush } from './Brush';
import { Erase } from './Erase';
import { KeyPoint } from './KeyPoint';
import { Polygon } from './Polygon';
import { Rect, Rect3Point } from './Rect';
import { Ellipse } from './Ellipse';
import { Zoom } from './Zoom';
import { Rotate } from './Rotate';
import { Brightness } from './Brightness';
import { Contrast } from './Contrast';
import { MagicWand } from './MagicWand';
import { Selection } from './Selection';

export { Brush, Erase, KeyPoint, Polygon, Rect, Rect3Point, Ellipse, Brightness, Contrast, Rotate, Zoom, MagicWand, Selection };
